/**
 * ProfileModal — centered popup shell shared by StatPopup and the avatar picker.
 * Mirrors iOS popup styling: maxWidth 320, borderRadius 20, padding 24,
 * --overlay-scrim backdrop, top-right close (×). dvh height; tap overlay to close.
 */
import { FC, ReactNode } from "react";
import { X } from "lucide-react";
import { colors, tokens } from "@/ui";

interface ProfileModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

const ProfileModal: FC<ProfileModalProps> = ({ open, onClose, children }) => {
  if (!open) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        height: "100dvh",
        backgroundColor: "var(--overlay-scrim)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
        zIndex: tokens.zIndex.sheet,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          backgroundColor: colors.white,
          borderRadius: 20,
          padding: 24,
          width: "100%",
          maxWidth: 320,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxSizing: "border-box",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            padding: 4,
            background: "none",
            border: "none",
            cursor: "pointer",
            lineHeight: 0,
          }}
        >
          <X size={24} color={colors.secondary} />
        </button>
        {children}
      </div>
    </div>
  );
};

export default ProfileModal;
